import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React, { useState } from 'react';

import MovementsTable from './Table';

const useStyles = makeStyles(() =>
  createStyles({
    table: {
      width: '100%',
    },
    tableCell: {
      padding: '8px !important',
      overflow: 'hidden',
      minWidth: '50px',
      maxWidth: '180px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important', // Reduced font size
    },
    tableCellTasa: {
      padding: '8px !important',
      overflow: 'hidden',
      maxWidth: '50px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important', // Reduced font size
      textAlign: 'right',
    },
    tableCellNames: {
      padding: '8px !important',
      overflow: 'hidden',
      maxWidth: '80px',
      whiteSpace: 'nowrap',
      fontSize: '14px !important', // Reduced font size
    },
    tableContainer: {
      border: '1px solid #e0e0e0',
      borderRadius: '10px',
    },
    tableBody: {
      backgroundColor: '#ffffff',
    },
    textField: {
      fontSize: '14px !important',
      padding: '8px !important',
    },
    textFieldAutocomplete: {
      fontSize: '14px !important',
      padding: '0px !important',
      minWidth: '120px !important',
    },
    iconButton: {
      padding: '5px',
    },
  }),
);

const MajorBookEntriesTable = (props: any) => {
  const { majorBookAccounts, groupedByCategoryAndBusiness } = props.entries;
  const { refreshData, startDate, endDate } = props;
  const [expandedDays, setExpandedDays] = useState<Record<number, boolean>>({});
  const classes = useStyles();

  const toggleDay = (dayIndex: number) => {
    setExpandedDays((prev) => ({ ...prev, [dayIndex]: !prev[dayIndex] }));
  };

  return (
    <div style={{ paddingBottom: 100 }}>
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Cuenta</TableCell>
              <TableCell>Nombre </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {majorBookAccounts.map((day: any, dayIndex: number) => (
              <React.Fragment key={dayIndex}>
                {/* Nivel 1: Día */}
                <TableRow
                  onClick={() => toggleDay(dayIndex)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: expandedDays[dayIndex]
                      ? '#f5f5f5'
                      : undefined,
                  }}
                >
                  <TableCell className={classes.tableCell}>
                    {day.account}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {day.accountName}
                  </TableCell>
                </TableRow>

                {expandedDays[dayIndex] && (
                  <TableRow>
                    <TableCell colSpan={3} style={{ padding: 0 }}>
                      <MovementsTable
                        groupedLines={day.groupedLines}
                        groupedByCategoryAndBusiness={
                          groupedByCategoryAndBusiness
                        }
                        refreshData={refreshData}
                        startDate={startDate}
                        endDate={endDate}
                      />
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default MajorBookEntriesTable;
